import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import { useRootAppStore } from "@hooks";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default observer(function ChatToggleButton() {
	const { chatViewStore } = useRootAppStore();

	const toggleChatWindow = () => {
		chatViewStore.toggleChatBox();
	};

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Desktop/ChatToggleButton.tsx"}
		>
			<button
				className={classNames(
					"chat__toggle btn btn--round btn--round--base btn--icon",
					{
						"chat__toggle--active": chatViewStore.chatBoxVisible,
					}
				)}
				onClick={toggleChatWindow}
			>
				<i
					className={classNames(
						"u-icon u-icon--sml",
						{
							"u-icon--chat--alt": !chatViewStore.chatBoxVisible,
							"u-icon--chat--str": chatViewStore.chatBoxVisible,
						},
						"u-color--core--snow"
					)}
				/>
			</button>
		</ErrorBoundaryWithPropagation>
	);
});
